// Aggregator for the campaign RTK Query api.
//
// The single createApi instance lives in ./campaignBaseApi; each domain module
// under ./endpoints injects its endpoints into that instance at import time.
// Importing this file therefore guarantees every endpoint is registered before
// the store (or any hook consumer) touches `campaignApi`.
import { campaignBaseApi } from './campaignBaseApi'
import './endpoints/callingListEndpoints'
import './endpoints/callOutcomesEndpoints'
import './endpoints/campaignsEndpoints'
import './endpoints/documentsEndpoints'
import './endpoints/linksEndpoints'
import './endpoints/objectivesEndpoints'
import './endpoints/ratingsEndpoints'

// Same object as campaignBaseApi — reducerPath, reducer and middleware are
// unchanged, so the legacy store registration keeps working as-is.
export const campaignApi = campaignBaseApi

export * from './endpoints/callingListEndpoints'
export * from './endpoints/callOutcomesEndpoints'
export * from './endpoints/campaignsEndpoints'
export * from './endpoints/documentsEndpoints'
export * from './endpoints/linksEndpoints'
export * from './endpoints/objectivesEndpoints'
export * from './endpoints/ratingsEndpoints'
